export default {
    name: 'typepage',
    state: {
        typepage: ""
    },
    getters: {
        getTypePage: state => {
            return state.typepage
        },
    },
    mutations: {
        TYPEPAGE: (state, payload) => {
            state.typepage = payload;
        }
    },
    actions: {
        SET_TYPEPAGE(store, payload) {
            store.commit('TYPEPAGE', payload)
        }
    }
}